<!--
<template functional>
    <h6>{{ data.attrs.rowValue }}</h6>
</template>
-->
<script>
const formatter = new Intl.NumberFormat(
  "en-US" /*, {
        style: "currency",
        currency: "USD"
      }*/
);
export default {
  name: "CashFlow2Hyperlink",
  functional: true,
  props: {
    openDrawer: {
      type: Function
    }
  },
  render: function (createElement, context) {
    let { column, row, rowValue, openDrawer } = context.data.attrs;
    //console.log("contexto: ",context)
    let element;
    let type;
    let arrayColumns = [
      "Disponibilidad inicio de mes",
      "Total de Ingreso",
      "Ingresos de Proyectos",
      "Contratos Activos",
      "Cuentas por Cobrar",
      "Cuentas Cobradas",
      "Total de Egreso",
      "Egresos de Proyectos",
      "Cuentas por Pagar",
      "Disponible"
    ];
    let months = {
      Month1: 1,
      Month2: 2,
      Month3: 3,
      Month4: 4,
      Month5: 5,
      Month6: 6,
      Month7: 7,
      Month8: 8,
      Month9: 9,
      Month10: 10,
      Month11: 11,
      Month12: 12
    };

    if (!arrayColumns.includes(row.Concept)) {
      // if (row.Id === -6) {
      //   return "available-row cf-bold";
      // }

      if (row.Id === -5 || row.Id === -4 || row.Id === 0) {
        type = "warning";
      }

      if (
        row.Id === -3 ||
        row.Id === -2 ||
        row.Id === -404 ||
        row.Id === -101 ||
        row.Id === -202 ||
        row.Id === -303 ||
        row.Id === -404
      ) {
        type = "success";
      }
      // if (
      //   row.colorNegro.includes(months[column]) &&
      //   !row.colorVerde.includes(months[column]) &&
      //   !row.colorRojo.includes(months[column])
      // ) {
      //   column;
      // } else if (row.colorVerde.includes(months[column])) {
      //   type = "success";
      // } else if (row.colorRojo.includes(months[column])) {
      //   type = "danger";
      // } else {
      //   type = "warning";
      // }
      //console.log("creando elemento en: ", row.Concept)

      element = createElement(
        "el-link",
        {
          attrs: {
            type: type
          },
          on: {
            click: () => {
              //let tableCell = context.data.attrs;
              if (context.props.openDrawer || openDrawer) {
                context.props.openDrawer
                  ? context.props.openDrawer(row, column, months[column])
                  : openDrawer(row, column, months[column]);
              }
            }
          }
        },
        rowValue != 0 ? formatter.format(rowValue) : ""
      );
    } else if (
      row.Concept == "Disponibilidad inicio de mes" ||
      row.Concept == "Disponible"
    ) {
      let elemnetId;

      if (rowValue < 0) {
        elemnetId = "balinidisp";
      } else {
        elemnetId = "";
      }

      element = createElement(
        "p",
        {
          attrs: {
            id: elemnetId
          }
        },
        formatter.format(rowValue)
      );

      return element;
    } else if (
      row.Concept == "Contratos Activos" ||
      row.Concept == "Cuentas por Cobrar" ||
      row.Concept == "Cuentas Cobradas" ||
      row.Concept == "Cuentas por Pagar"
    ) {
      element = createElement(
        "el-link",
        {
          attrs: {
            type: type
          },
          on: {
            click: () => {
              //let tableCell = context.data.attrs;
              if (context.props.openDrawer || openDrawer) {
                context.props.openDrawer
                  ? context.props.openDrawer(row, column, months[column])
                  : openDrawer(row, column, months[column]);
              }
            }
          }
        },
        rowValue > 0 ? formatter.format(rowValue) : ""
      );
    } else {
      //console.log("formatter: ", formatter)
      element = createElement(
        "p",
        {
          attrs: {}
        },
        rowValue != 0 ? formatter.format(rowValue) : ""
      );
    }

    return element;
  }
};
</script>
<style scoped>
#balinidisp {
  color: red;
}
</style>
